import moment, { isMoment } from 'moment';
import { Moment } from 'moment';

export interface Time {
	hours: number;
	minutes: number;
}

export const getDateWithTime = (date: Moment, time: Moment | Time) => {
	const hours = isMoment(time) ? time.hours() : time.hours;
	const minutes = isMoment(time) ? time.minutes() : time.minutes;

	return moment(date)
		.clone()
		.startOf('day')
		.add(hours, 'hours')
		.add(minutes, 'minutes');
};
